import { render, staticRenderFns } from "./TeacherTag_v2.vue?vue&type=template&id=0d3febe3&"
import script from "./TeacherTag_v2.vue?vue&type=script&lang=js&"
export * from "./TeacherTag_v2.vue?vue&type=script&lang=js&"
import style0 from "./TeacherTag_v2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeacherTag_v2.vue"
export default component.exports